var NAVIGATOR_PANE = "_navigator";
var NAVIGATOR_AXIS = NAVIGATOR_PANE;

export { NAVIGATOR_AXIS, NAVIGATOR_PANE };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/stock/constants.js
// module id = 653
// module chunks = 29